import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import API from "@src/API.js";
import "../../style/scss/Recruit.scss";

export default function SeekerCoachingPanel() {
  const [coaching, setCoaching] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const resp = await API.getAsync("/SeekerCoaching");
        if (!cancelled && resp?.ok) setCoaching(resp.jsonData);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading || !coaching) return null;

  const scarce = coaching.IsScarce ?? coaching.isScarce;
  const lookingNow = coaching.LookingNow ?? coaching.lookingNow;
  const scarcity = coaching.ScarcityAdvice || coaching.scarcityAdvice || [];
  const interest = coaching.InterestChangeCoaching || coaching.interestChangeCoaching || [];
  const matchCount = coaching.ActiveMatchCount ?? coaching.activeMatchCount ?? 0;

  if (!scarce && !lookingNow) return null;

  return (
    <div className="tabsection SeekerCoachingPanel">
      <div className="listTitle">
        <span>Placement coaching</span>
      </div>
      <p className="byline">
        Active system matches: {matchCount}. CareerMaster finds openings for you — this is not a job
        board.
      </p>

      {lookingNow && interest.length > 0 ? (
        <div className="coachingBlock">
          <h3>You&apos;re looking now</h3>
          <ul>
            {interest.map((t) => (
              <li key={t.Key || t.key}>
                <strong>{t.Title || t.title}</strong>
                <div>{t.Guidance || t.guidance}</div>
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      {scarce && scarcity.length > 0 ? (
        <div className="coachingBlock">
          <h3>Few matches — flexibility tips</h3>
          <ul>
            {scarcity.map((t) => (
              <li key={t.Key || t.key}>
                <strong>{t.Title || t.title}</strong>
                <div>{t.Guidance || t.guidance}</div>
              </li>
            ))}
          </ul>
          <p>
            <Link to="/careers">Review careers</Link>
            {" · "}
            <Link to="/account">Account prefs</Link>
          </p>
        </div>
      ) : null}
    </div>
  );
}
